import { render } from "./App.vue?vue&type=template&id=bafbd49a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bafbd49a&lang=less"

import exportComponent from "/Users/tomotakayajima/Sites/localhost/ai/show/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__